// Locale strings of report 2.6 (accounting-balance), accountant's document 2026-10-03.
// Merged ONCE into finance.reports2.<camelCaseSlug> by ./index.js: use
// $t("finance.reports2.<camelCaseSlug>.<key>"). Owned by this report only.
export default {
  pageTitle: "Accounting Balance (cumulative)",
  title: "Accounting Balance (cumulative)",
  reportDate: "Report date",
  yearStart: "Year start",
  maxLevel: "Level",
  allLevels: "All levels",
  accountType: "Account type",
  allTypes: "All types",
  types: {
    ASSET: "Assets",
    LIABILITY: "Liabilities",
    EQUITY: "Equity",
    REVENUE: "Revenue",
    EXPENSE: "Expenses",
  },
  parentAccount: "Parent account",
  hideZero: "Hide zero balances",
  showChildren: "Show sub-accounts",
  balanceFrom: "Balance from",
  balanceTo: "Balance to",
  search: "Search (account code or name)",
  columns: {
    serial: "#",
    code: "Account code",
    name: "Account name",
    level: "Level",
    parent: "Parent account",
    normalBalance: "Normal balance",
    balance: "Balance",
    balanceSide: "Balance type",
    notes: "Notes",
  },
  summaryTitle: "Report summary",
  accountsCount: "Accounts",
  debitTotal: "Total debit balances",
  creditTotal: "Total credit balances",
  difference: "Difference",
  status: "Status",
  abnormalCount: "Abnormal balances",
  ledgerStatus: "Ledger balance",
  scopedSummary: "Summary computed within the filter scope (parent account / account type)",
  unclassified: "Unclassified",
  contextRow: "Shown to keep the account tree (outside the filter)",
  alertsTitle: "Alerts",
  notesTitle: "Notes",
  sheetName: "Accounting balance",
  periodLine: "From {from} to {to}",
};
